module.exports = __webpack_public_path__ + "static/media/g-4-a.714b7265.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gadgets/g-4-a.jpg
// module id = 1136
// module chunks = 33